import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Box,
  Divider,
  Stack,
} from '@mui/material';
import type { BackupJob, Provider, RestoreJob } from '@repo/api-gw-sdk';
import { useState } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@/components/accordion';
import { CloudProviderCircle } from '@/components/cloudProviderIndicator';
import { useFields } from '@/components/table/hooks';
import type { FilterProperty } from '@/types/advanceFilter';

import { JobSummaryContentWrapper } from './jobSummaryContentWrapper';

export const OperationSummary = ({
  job,
  fromTitle,
  fromFields,
  toTitle,
  toFields,
  fromCloudProvider,
  toCloudProvider,
}: {
  job: BackupJob | RestoreJob;
  fromTitle: string;
  fromFields: FilterProperty[];
  toTitle: string;
  toFields: FilterProperty[];
  fromCloudProvider: Provider;
  toCloudProvider: Provider;
}) => {
  const [fromOpen, setFromOpen] = useState(true);
  const [toOpen, setToOpen] = useState(true);
  const filteredFromFields = useFields(fromFields)
    .map((x) => ({
      id: x.id,
      title: x.title(job),
      group: x.group,
      value: x.value(job, () => Promise.resolve()),
    }))
    .filter((x) => !!x.value);

  const filteredToFields = useFields(toFields)
    .map((x) => ({
      id: x.id,
      title: x.title(job),
      group: x.group,
      value: x.value(job, () => Promise.resolve()),
    }))
    .filter((x) => !!x.value);

  return (
    <Box>
      <MuiAccordion disableGutters defaultExpanded>
        <MuiAccordionSummary data-testid='oprestion-summary'>
          Operation summary
        </MuiAccordionSummary>
        <MuiAccordionDetails sx={{ padding: '0px' }}>
          <Accordion
            sx={{ padding: ' 24px 40px' }}
            expanded={fromOpen}
            onChange={() => setFromOpen(!fromOpen)}
          >
            <AccordionSummary>
              <Stack
                width='100%'
                direction='row'
                justifyContent='space-between'
                alignItems='center'
              >
                {fromTitle}
                {!fromOpen && (
                  <CloudProviderCircle cloudProvider={fromCloudProvider} />
                )}
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <JobSummaryContentWrapper
                cloudProvider={fromCloudProvider}
                fields={filteredFromFields}
              />
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion
            sx={{ padding: ' 24px 40px' }}
            expanded={toOpen}
            onChange={() => setToOpen(!toOpen)}
          >
            <AccordionSummary>
              <Stack
                width='100%'
                direction='row'
                justifyContent='space-between'
                alignItems='center'
              >
                {toTitle}
                {!toOpen && (
                  <CloudProviderCircle cloudProvider={toCloudProvider} />
                )}
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <JobSummaryContentWrapper
                cloudProvider={toCloudProvider}
                fields={filteredToFields}
              />
            </AccordionDetails>
          </Accordion>
          <Divider />
        </MuiAccordionDetails>
      </MuiAccordion>
    </Box>
  );
};
